export const SET_STAGE = "SET_STAGE";
export const SET_SOURCE = "SET_SOURCE";
export const OPEN_MENU = "OPEN_MENU";
export const SET_LOADER = "SET_LOADER";
export const SET_ERROR = "SET_ERROR";
export const SET_MESSAGE = "SET_MESSAGE";
export const SET_LOGOUT = "SET_LOGOUT";
export const SET_IS_CONNECTED = "SET_IS_CONNECTED";
export const SET_FOCUS = "SET_FOCUS";
export const LOGOUT = "LOGOUT";
export const CALL_GA = "CALL_GA";
export const CALL_GA_EVENT = "CALL_GA_EVENT";
export const SET_IS_CAL_PROVIDER = "SET_IS_CAL_PROVIDER";

export const SET_OTP_DETAILS = "SET_OTP_DETAILS";
export const SET_OTP_PHONE = "SET_OTP_PHONE";
export const SET_OTP_TOKEN = "SET_OTP_TOKEN";

export const POPULATE_CARDS = "POPULATE_CARDS";
export const SELECT_CARD = "SELECT_CARD";
export const SET_PIN = "SET_PIN";
export const SET_TIMER = "SET_TIMER";

export const SET_CARDS = "SET_CARDS";

export const Stages = {
  welcome: "WELCOME",
  // sendOtp: "SEND_OTP",
  // verifyOtp: "VERIFY_OTP",
  login: "LOGIN",
  cards: "CARDS",
  pin: "PIN",
  thankYou: "THANK_YOU",
  loader: "LOADER",
  error: "ERROR",
};

//////////////////////////
////////APP///////////////
//////////////////////////
export const setCardsResponse = (cardsResponse) => {
  return {
    type: SET_CARDS,
    cardsResponse,
  };
};

export const setStage = (stage) => {
  return {
    type: SET_STAGE,
    stage,
  };
};

export const setSource = (source) => {
  return {
    type: SET_SOURCE,
    source,
  };
};

export const setFocus = (refName) => {
  return {
    type: SET_FOCUS,
    refName,
  };
};

export const setLoader = (isLoading) => {
  return {
    type: SET_LOADER,
    isLoading,
  };
};

export const openMenu = (isMenuOpen) => {
  return {
    type: OPEN_MENU,
    isMenuOpen,
  };
};

export const setError = (code, text) => {
  return {
    type: SET_ERROR,
    code,
    text,
    stage: Stages.error,
  };
};

export const setMessage = (id, text, isSrError) => {
  return {
    type: SET_MESSAGE,
    id,
    text,
    isSrError,
  };
};
export const setIsConnected = (isConnected) => {
  return {
    type: SET_IS_CONNECTED,
    isConnected,
  };
};

export const setLogout = (
  url,
  stage,
  text,
  topImg,
  okText,
  cancelText,
  sessionExpired
) => {
  return {
    type: SET_LOGOUT,
    url,
    stage,
    text,
    topImg,
    okText,
    cancelText,
    sessionExpired,
  };
};

export const logout = (stage) => {
  return {
    type: LOGOUT,
    stage: Stages.thankYou,
  };
};

export const callGoogleAnalytics = (page, error) => {
  return {
    type: CALL_GA,
    page,
    error,
  };
};

export const callGoogleAnalyticsEvent = (category, action, label) => {
  return {
    type: CALL_GA_EVENT,
    category,
    action,
    label,
  };
};

export const setIsCalProvider = (isCalProvider) => {
  return {
    type: SET_IS_CAL_PROVIDER,
    isCalProvider,
  };
};

//////////////////////////
////////OTP///////////////
//////////////////////////

export const setOtpDetails = (details) => {
  return {
    type: SET_OTP_DETAILS,
    otp: details,
  };
};

export const setOtpPhone = (phone) => {
  return {
    type: SET_OTP_PHONE,
    phone,
  };
};

export const setOtpToken = (token) => {
  return {
    type: SET_OTP_TOKEN,
    token,
  };
};

//////////////////////////
////////CARD//////////////
//////////////////////////

export const populateCards = (cards) => {
  return {
    type: POPULATE_CARDS,
    cards,
  };
};

export const selectCard = (last4Digits) => {
  return {
    type: SELECT_CARD,
    last4Digits,
  };
};

export const setPin = (pin) => {
  return {
    type: SET_PIN,
    pin,
  };
};

export const setTimer = (percent, time) => {
  return {
    type: SET_TIMER,
    percent,
    time,
  };
};



// WEBPACK FOOTER //
// ./src/actions/actions.js